/* Lazy loader for tippy videos (see snippets/tippy-video.liquid) and
   off-screen pause for the marquee animations.

   Any element matching video[data-tippy-video] is loaded (data-src -> src)
   and played when it approaches the viewport, and paused when it leaves.
   Sections that inject videos dynamically (buybox, product gallery) dispatch
   document event "tippy:video:refresh" after rendering to pick up new ones. */
(function () {
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var videoObserver = null;

  function startVideo(video) {
    if (video.dataset.src) {
      video.src = video.dataset.src;
      delete video.dataset.src;
    }
    // The muted content attribute alone is not reliably honored for autoplay
    // on dynamically inserted videos — set the property explicitly.
    video.muted = true;
    if (!reducedMotion) {
      var p = video.play();
      if (p && p.catch) {
        p.catch(function () {
          // With preload="none" play() can reject before any data is buffered
          // (intermittent on mobile Safari). Kick the load and retry once ready.
          video.addEventListener(
            'canplay',
            function () {
              var r = video.play();
              if (r && r.catch) r.catch(function () {});
            },
            { once: true }
          );
          if (video.readyState === 0) video.load();
        });
      }
    }
  }

  function scanVideos() {
    var videos = document.querySelectorAll('video[data-tippy-video]:not([data-tippy-observed])');
    videos.forEach(function (video) {
      video.setAttribute('data-tippy-observed', '');
      if (videoObserver) {
        videoObserver.observe(video);
      } else {
        startVideo(video);
      }
    });
  }

  function initVideos() {
    if ('IntersectionObserver' in window && !videoObserver) {
      videoObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target;
            if (entry.isIntersecting) {
              startVideo(video);
            } else if (!video.paused) {
              video.pause();
            }
          });
        },
        { rootMargin: '300px 0px' }
      );
    }
    scanVideos();
  }

  /* Pause the infinite ticker/marquee animations while off-screen —
     with ~9 running at once they dominate Style & Layout time. */
  function initMarquees() {
    var marquees = document.querySelectorAll('.ticker, .tippy-logo-marquee, .tippy-announcement');
    if (!marquees.length || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          entry.target.classList.toggle('is-offscreen', !entry.isIntersecting);
        });
      },
      { rootMargin: '100px 0px' }
    );
    marquees.forEach(function (el) {
      observer.observe(el);
    });
  }

  document.addEventListener('tippy:video:refresh', scanVideos);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initVideos();
      initMarquees();
    });
  } else {
    initVideos();
    initMarquees();
  }
})();
